import { httpClient } from "../http/httpClient";

export interface Commission {
  table: string;
  max: number;
  name: string;
  seller: number;
  leader: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateTeamDefaultdata {
  goal?: {
    value: number;
    commission: number;
  }[];
  commission?: Commission[];
}

export interface UpdateTeamResponse {
  _id: string;
  name: string;
  about: string;
  manager_id: string;
  leader_id: string;
  comission_rate: number;
  members: string[];
  commission: Commission[];
}

export const updateDefaultTeam = async (updateData: UpdateTeamDefaultdata) => {
  const { data } = await httpClient.put<UpdateTeamResponse>("config/team", {
    ...updateData,
    type: "TEAM",
  });

  return data;
};
